import { t } from '@transifex/native';
import type { JSX } from 'react';
import styled from 'styled-components';

import { getConfig } from 'pkg/config/app';
import * as styles from 'pkg/config/styles';

import type * as models from 'pkg/api/models';
import { durationTimestamp } from 'pkg/api/models/video/fmt';
import { isNew } from 'pkg/api/models/video/guards';
import { thumbnail as videoThumbnail } from 'pkg/api/models/video/utils';
import { useCurrentOrganization } from 'pkg/identity';
import * as routes from 'pkg/router/routes';

import GroupItem, { VisibilityLabel } from 'components/library/GroupItem';
import type { GroupItemAction } from 'components/library/GroupItem';

const DurationLabel = styled(VisibilityLabel)`
	left: auto;
	right: var(--spacing-4);

	@media ${styles.breakpoint.small} {
		left: auto;
		right: var(--spacing-3);
	}
`;

interface VideoGroupItemProps {
	href?: string;
	embedded?: boolean;
	item: models.video.Video;
	actions?: GroupItemAction<models.video.Video>[];
	queryString?: string;
}

export default function VideoGroupItem({
	href,
	embedded,
	item,
	actions,
	queryString,
}: VideoGroupItemProps): JSX.Element {
	const org = useCurrentOrganization();
	const visibilityLabel = item.groupId
		? item.group?.name || t('Team')
		: t('Only me');
	const thumbnail = videoThumbnail(item);

	if (!href) {
		href = routes.Video.Show(org.id, item.id);
	}

	if (queryString) {
		href += queryString;
	}

	return (
		<GroupItem
			item={item}
			href={href}
			actions={actions}
			author={item.author}
			title={item.title}
			createdAt={item.createdAt}
			isNew={isNew(item)}
			visibilityLabel={visibilityLabel}
			embedded={embedded}>
			{thumbnail ? (
				<img src={thumbnail} loading="lazy" />
			) : (
				<img
					src={getConfig().assetUrl + '/img/library-placeholder.svg'}
					loading="lazy"
				/>
			)}
			<DurationLabel data-has-image={!!thumbnail}>
				{durationTimestamp(item)}
			</DurationLabel>
		</GroupItem>
	);
}
